const userReducer = (state = {}, action) => {
    switch (action.type) {
        case 'LOGIN':
            return Object.assign({}, state, {
                data: null,
                hasUserData: null, // has app went through login process
                isLoading: true,
                error: false,
                errorMessage: null,
                logout: false
            });
        case 'DONE_LOGIN':
            return Object.assign({}, state, {
                data: action.data,
                hasUserData: true,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_LOGIN':
            return Object.assign({}, state, {
                data: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'REGISTER':
            return Object.assign({}, state, {
                register: null,
                isLoading: true,
                error: false,
                errorMessage: null
            });
        case 'DONE_REGISTER':
            return Object.assign({}, state, {
                register: true,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_REGISTER':
            return Object.assign({}, state, {
                register: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'RESET_PASSWORD':
            return Object.assign({}, state, {
                reset: null,
                isLoading: true,
                error: false,
                errorMessage: null
            });
        case 'DONE_RESET_PASSWORD':
            return Object.assign({}, state, {
                reset: true,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_RESET_PASSWORD':
            return Object.assign({}, state, {
                reset: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'RESET_PASSWORD_CONFIRM':
            return Object.assign({}, state, {
                resetConfirm: null,
                isLoading: true,
                error: false,
                errorMessage: null
            });
        case 'DONE_RESET_PASSWORD_CONFIRM':
            return Object.assign({}, state, {
                resetConfirm: true,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_RESET_PASSWORD_CONFIRM':
            return Object.assign({}, state, {
                resetConfirm: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'SEND_SUPPORT':
            return Object.assign({}, state, {
                support: null,
                isLoading: true,
                error: false,
                errorMessage: null
            });
        case 'DONE_SEND_SUPPORT':
            return Object.assign({}, state, {
                support: true,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_SEND_SUPPORT':
            return Object.assign({}, state, {
                support: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });

        case 'SEND_DEMO_REQUEST':
            return Object.assign({}, state, {
                requestDemo: null,
                isLoading: true,
                error: false,
                errorMessage: null
            });
        case 'DONE_SEND_DEMO_REQUEST':
            return Object.assign({}, state, {
                requestDemo: true,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_SEND_DEMO_REQUEST':
            return Object.assign({}, state, {
                requestDemo: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'UPDATE_USER_INFO':
            return Object.assign({}, state, {
                data: action.data
            });
        case 'LOGOUT_ME':
            return Object.assign({}, state, {
                logout: true,
                isLoading: false
            });
        case 'RESET_USER_MESSAGE':
            return Object.assign({}, state, {
                requestDemo: false,
                support: false,
                reset: false,
                error: false,
                errorMessage: null
            });
        case 'UPDATE_PASSWORD':
            return Object.assign({}, state, {
                reset: null,
                isLoading: true,
                error: false,
                errorMessage: null
            });
        case 'DONE_UPDATE_PASSWORD':
            return Object.assign({}, state, {
                reset: true,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_UPDATE_PASSWORD':
            return Object.assign({}, state, {
                reset: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'GET_USER_DATA':
            return Object.assign({}, state, {
                isLoading: true,
                hasUserData: false,
                error: false,
            });
        case 'DONE_GET_USER_DATA':
            return Object.assign({}, state, {
                isLoading: false,
                hasUserData: true,
                error: false,
            });
        case 'ERROR_GET_USER_DATA':
            return Object.assign({}, state, {
                isLoading: false,
                hasUserData: false,
                error: true,
                errorMessage: action.data
            });
        case 'DONE_FIRST_FACTOR':
            return Object.assign({}, state, {
                data: action.data,
                isLoading: false,
                hasUserData: false,
                error: false,
                errorMessage: false
            });
        case 'VERIFY_TOKEN':
            return Object.assign({}, state, {
                data: null,
                isLoading: true,
                hasUserData: false,
                error: false,
                errorMessage: false
            });
        case 'DONE_VERIFY_TOKEN':
            return Object.assign({}, state, {
                isLoading: false,
                hasUserData: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_VERIFY_TOKEN':
            return Object.assign({}, state, {
                data: null,
                isLoading: false,
                hasUserData: false,
                error: true,
                errorMessage: action.data
            });
        case 'RESEND_TOKEN':
            return Object.assign({}, state, {
                data: null,
                isLoading: true,
                hasUserData: false,
                error: false,
                errorMessage: false
            });
        case 'DONE_RESEND_TOKEN':
            return Object.assign({}, state, {
                isLoading: false,
                hasUserData: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_RESEND_TOKEN':
            return Object.assign({}, state, {
                data: null,
                isLoading: false,
                hasUserData: false,
                error: true,
                errorMessage: action.data
            });
        default:
            return state;
    }
};

export default userReducer;
